import { render, staticRenderFns } from "./WineListHeader.vue?vue&type=template&id=501682d2&"
import script from "./WineListHeader.vue?vue&type=script&lang=js&"
export * from "./WineListHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports